const MODE_KEY = "billsarthi:active-data-workspace";
const WORKSPACE_KEYS = ["productlistx", "categorylistx"];
const PROFILE_FIELDS = [
  "restaurant_name", "restaurantname", "name", "email",
  "addressline1", "addressline2", "addressline3",
  "issoundenable", "isvibrationenable",
  "customfield1", "customfield2", "customfield3", "gstno", "upiaddress",
  "showlogoonprinter", "showqrcodeonprinter", "showphonenumberonprinter",
  "showthanksonbill", "daily_order_sequence_reset_enabled",
  "daily_kot_sequence_reset_enabled",
  "multiple_price_lists_enabled", "country_code", "currency_code", "locale",
  "timezone", "tax_regime", "photo", "avatar_url", "restaurant_logo",
  "__offlineProfile",
];

const slotKey = (mode, key) => `billsarthi:${mode}-workspace:${key}`;
const profileSlotKey = (mode, restaurantId) =>
  `billsarthi:${mode}-workspace:profile:${restaurantId}`;

const readSession = () => {
  try { return JSON.parse(window.localStorage.getItem("userData") || "{}"); }
  catch { return {}; }
};

const profileSnapshot = (data = {}) => Object.fromEntries(
  PROFILE_FIELDS
    .filter((key) => Object.prototype.hasOwnProperty.call(data, key))
    .map((key) => [key, data[key]])
);

const saveProfileSlot = (mode, session) => {
  const restaurantId = session?.data?.id;
  if (!restaurantId) return;
  window.localStorage.setItem(
    profileSlotKey(mode, restaurantId),
    JSON.stringify(profileSnapshot(session.data))
  );
};

const restoreProfileSlot = (mode, session) => {
  const restaurantId = session?.data?.id;
  if (!restaurantId) return false;
  const raw = window.localStorage.getItem(profileSlotKey(mode, restaurantId));
  if (!raw) return false;
  let profile;
  try { profile = JSON.parse(raw); } catch { return false; }
  const data = { ...(session.data || {}) };
  PROFILE_FIELDS.forEach((key) => delete data[key]);
  Object.assign(data, profile);

  const context = session?.account_link_context;
  const accounts = Array.isArray(context?.accounts)
    ? context.accounts.map((account) =>
        String(account?.id ?? "") === String(restaurantId)
          ? { ...account, ...profile }
          : account)
    : null;
  window.localStorage.setItem("userData", JSON.stringify({
    ...session,
    data,
    ...(accounts ? { account_link_context: { ...context, accounts } } : {}),
  }));
  return true;
};

// A few legacy screens still read these catalog snapshots directly. Swap the
// snapshots with the Electron database so local-only catalog changes cannot
// leak into the online workspace after the mode changes.
export const switchLocalWorkspace = (offlineEnabled) => {
  if (typeof window === "undefined" || !window.localStorage) return;
  const nextMode = offlineEnabled ? "offline" : "online";
  const previousMode = window.localStorage.getItem(MODE_KEY);

  if (!previousMode) {
    window.localStorage.setItem(MODE_KEY, nextMode);
    WORKSPACE_KEYS.forEach((key) => {
      const value = window.localStorage.getItem(key);
      if (value !== null) window.localStorage.setItem(slotKey(nextMode, key), value);
    });
    const session = readSession();
    saveProfileSlot(nextMode, session);
    if (nextMode === "offline") saveProfileSlot("online", session);
    return;
  }
  if (previousMode === nextMode) {
    const session = readSession();
    const restaurantId = session?.data?.id;
    if (restaurantId && !window.localStorage.getItem(profileSlotKey(nextMode, restaurantId))) {
      saveProfileSlot(nextMode, session);
    }
    if (
      nextMode === "offline" && restaurantId &&
      !window.localStorage.getItem(profileSlotKey("online", restaurantId))
    ) {
      saveProfileSlot("online", session);
    }
    return;
  }

  const session = readSession();
  saveProfileSlot(previousMode, session);

  WORKSPACE_KEYS.forEach((key) => {
    const currentValue = window.localStorage.getItem(key);
    if (currentValue === null) window.localStorage.removeItem(slotKey(previousMode, key));
    else window.localStorage.setItem(slotKey(previousMode, key), currentValue);

    const nextValue = window.localStorage.getItem(slotKey(nextMode, key));
    if (nextValue === null) window.localStorage.removeItem(key);
    else window.localStorage.setItem(key, nextValue);
  });
  if (!restoreProfileSlot(nextMode, session) && nextMode === "offline") {
    saveProfileSlot("offline", session);
  }
  window.localStorage.setItem(MODE_KEY, nextMode);
};
